import { z } from 'zod';

const monthYearRegex = /^\d{4}-\d{2}$/;

export const ExpenseCategorySchema = z.enum([
  'electricity',
  'water',
  'salary',
  'maintenance',
  'supplies',
  'cleaning',
  'repairs',
  'equipment',
  'refund',
  'advertising',
  'security',
  'other',
]);

export const ExpensePaymentMethodSchema = z.enum(['Online', 'Cash']);

export const CreateExpenseSchema = z.object({
  amount: z
    .number({ invalid_type_error: 'Amount must be a number' })
    .positive('Amount must be greater than 0')
    .max(1000000, 'Amount cannot exceed ₹10,00,000'),
  date: z
    .union([z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format (YYYY-MM-DD)'), z.date()])
    .transform((val) => (typeof val === 'string' ? new Date(val) : val)),
  category: ExpenseCategorySchema,
  description: z.string().min(3, 'Description must be at least 3 characters').max(500, 'Description cannot exceed 500 characters'),
  paymentMethod: ExpensePaymentMethodSchema,
  receiptReference: z.string().max(100).optional().or(z.literal('')),
  monthAllocation: z.string().regex(monthYearRegex, 'Month allocation must be in YYYY-MM format'),
  approvedBy: z.string().max(100).optional().or(z.literal('')),
  tags: z.array(z.string().max(50)).optional().default([]),
});

export type CreateExpenseInput = z.infer<typeof CreateExpenseSchema>;
